(() => {
  function connect() {
    const select = document.getElementById('variantselect');
    const output = document.getElementById('em-product-structured-data');
    const source = document.getElementById('em-variant-structured-data');
    if (!select || !output || !source) return;
    let variants;
    try { variants = JSON.parse(source.textContent); } catch (_) { return; }
    const refresh = () => {
      const variant = variants[select.value];
      if (variant) output.textContent = JSON.stringify(variant);
    };
    select.addEventListener('change', refresh);
    window.addEventListener('pageshow', refresh);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect);
  else connect();
})();
